/* eslint-disable react-hooks/exhaustive-deps */
import { Countries, Currencies, WalletTypes } from '@constants/enums';
import { COUNTRY_CURRENCY } from '@efex-components/common/Form/config';
import useBoolean from '@main-hooks/useBoolean';
import useCombineBalances from '@main-hooks/useCombinedBalances';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useWalletTabs } from '../../tabsWallets/hooks/useWalletTabs';
import { TAB_GLOBAL_ACCOUNT, accountTabLabels } from '../constants';

interface IWalletsProps {
  onAddFundsCurrency: (currency: Currencies, walletType?: WalletTypes) => void;
}

const useWallets = ({ onAddFundsCurrency }: IWalletsProps) => {
  const { t } = useTranslation();
  const userProfile = useSelector(selectProfileData);
  const originCurrency =
    userProfile?.company.accountCurrency ??
    COUNTRY_CURRENCY[
      (userProfile?.company.country as keyof typeof COUNTRY_CURRENCY) ||
        Countries.USA
    ];
  const [currentTab, setCurrentTab] = useState<number>(TAB_GLOBAL_ACCOUNT);

  const [
    isConvertModalOpen,
    { setTrue: showConvertModal, setFalse: hideConvertModal },
  ] = useBoolean(false);

  const {
    reloadWallet,
    fixedGeneralBalance,
    loadingBalances,
    loadingBalancesError,
    dataMixed,
  } = useCombineBalances();

  const { filteredWalletData, activeTabIndices, activeTabLabels } =
    useWalletTabs({
      walletsData: dataMixed.walletsDataMixed || [],
      currentTab,
      accountTabLabels,
      t,
    });

  const handleOnChangeTabs = (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    setCurrentTab(newValue);
  };

  const handleAddFunds = (currency: Currencies, walletType?: WalletTypes) => {
    onAddFundsCurrency(currency, walletType);
  };

  return {
    userProfile,
    dataMixed,
    loadingBalances,
    loadingBalancesError,
    fixedGeneralBalance,
    originCurrency,
    filteredWalletData,
    activeTabIndices,
    activeTabLabels,
    isConvertModalOpen,
    currentTab,
    handleOnChangeTabs,
    handleAddFunds,
    showConvertModal,
    hideConvertModal,
    reloadWallet,
  };
};

export default useWallets;
